import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import {
  sumOfGroupTotals,
  totalRowPercentageWithGrandTotals,
} from '../../../../../react-table/helpers/rowTotals';
import CarrierNestingLocationReportMode from "./CarrierNestingLocationReportMode";

export const getLocationTabNavigationProps = carrierData => (rowInfo, index) => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.CARDIT_NESTING_DETAILS_801.id,
    mainReportId: ReportDefinitions.CARDIT_NESTING_LOCATION_801.id,
    requestParams: {
      postalOperator: rowInfo.row.postalOperator,
      originAirport: rowInfo.row.originAirport[index],
      destinationAirport: rowInfo.row.destinationAirport[index] === 'Total' ? '' : rowInfo.row.destinationAirport[index],
      carriers: carrierData.carriers,
      isSubtotal: index === 0,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {}
);

export default (data, carrierData, mode = CarrierNestingLocationReportMode.percentage) => {
  const {
    NonZeroNumberColumn,
    MultilineColumn,
    MultilineNumberGroupedColumn,
    MultilinePercentageGroupedColumn,
    MultilineNumberNavigationWithFooterColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new MultilineColumn('Postal operator', 'postalOperator')
          .withTotalHeader('Total', 'bg-total-darkGrey'),
        new MultilineColumn('Origin airport', 'originAirport')
          .withTotalHeader('', 'bg-total-darkGrey'),
        new MultilineColumn('Destination', 'destinationAirport')
          .withTotalHeader('', 'bg-total-darkGrey'),
      ],
    },
    {
      Header: 'Consignment',
      columns: [
        new MultilineNumberGroupedColumn('Total', 'consignment.total')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-darkGrey'),

        new MultilineNumberGroupedColumn('CJID nested', 'consignment.cjidNested', true, 'consignment.pctCjidNested')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-darkGrey')
          .withShow(mode === CarrierNestingLocationReportMode.number),
        new MultilineNumberGroupedColumn('ULD ID nested', 'consignment.uldIdnested', true, 'consignment.pctUldIdNested')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-darkGrey')
          .withShow(mode === CarrierNestingLocationReportMode.number),
        new MultilinePercentageGroupedColumn('% CJID nested', 'consignment.pctCjidNested', true, 'consignment.cjidNested')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['consignment.cjidNested', 'consignment.total']), 'bg-total-darkGrey')
          .withShow(mode === CarrierNestingLocationReportMode.percentage),
        new MultilinePercentageGroupedColumn('% ULD ID nested', 'consignment.pctUldIdNested', true, 'consignment.uldIdNested')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['consignment.uldIdnested', 'consignment.total']), 'bg-total-darkGrey')
          .withShow(mode === CarrierNestingLocationReportMode.percentage),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new MultilineNumberNavigationWithFooterColumn(
          new NonZeroNumberColumn('Total', 'receptacles.total')
            .withTotalHeader(sumOfGroupTotals, 'bg-total-darkGrey'),
          getLocationTabNavigationProps(carrierData),
        ),

        new MultilineNumberGroupedColumn('CJID nested', 'receptacles.cjidNested', true, 'receptacles.pctCjidNested')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-darkGrey')
          .withShow(mode === CarrierNestingLocationReportMode.number),
        new MultilineNumberGroupedColumn('ULD ID nested', 'receptacles.uldIdnested', true, 'receptacles.pctUldIdNested')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-darkGrey')
          .withShow(mode === CarrierNestingLocationReportMode.number),
        new MultilinePercentageGroupedColumn('% CJID nested', 'receptacles.pctCjidNested', true, 'receptacles.cjidNested')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['receptacles.cjidNested', 'receptacles.total']), 'bg-total-darkGrey')
          .withShow(mode === CarrierNestingLocationReportMode.percentage),
        new MultilinePercentageGroupedColumn('% ULD ID nested', 'receptacles.pctUldIdNested', true, 'receptacles.uldIdNested')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['receptacles.uldIdnested', 'receptacles.total']), 'bg-total-darkGrey')
          .withShow(mode === CarrierNestingLocationReportMode.percentage),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.CARDIT_NESTING_DETAILS_801.id,
        mainReportId: ReportDefinitions.CARDIT_NESTING_LOCATION_801.id,
        requestParams: {
          isTotal: carrierData.postalOperator === '*', // since report expected to have one only group - * is handled on cape-be by reverting it back to ''
          isSubtotal: carrierData.postalOperator !== '*', // since report expected to have one only group - * is handled on cape-be by reverting it back to ''
          postalOperator: carrierData.postalOperator,
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
